module.exports = __webpack_public_path__ + "img/pic1.5060e4fd.webp";